import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Flame } from 'lucide-react';
import { useCart } from '../context/CartContext';
import CaliLetters from './CaliLetters';

const badgeColor = (badge) => {
  switch (badge) {
    case 'PROMO': return 'bg-[#ff2e2e] text-white';
    case 'BESTSELLER': return 'bg-[#a6e22e] text-black';
    case 'NOWOŚĆ': return 'bg-[#ffb000] text-black';
    case 'WKRÓTCE': return 'bg-white/20 text-white';
    default: return 'bg-white/15 text-white';
  }
};

const ProductCard = ({ product }) => {
  const { addItem } = useCart();

  return (
    <div className="product-card group relative cb-panel rounded-2xl border border-white/10 overflow-hidden flex flex-col">
      {product.badge && (
        <span className={`absolute top-3 left-3 z-10 text-[11px] font-bold px-2.5 py-1 rounded-full ${badgeColor(product.badge)}`}>
          {product.badge}
        </span>
      )}
      <span className="absolute top-3 right-3 z-10 text-[11px] font-bold px-2.5 py-1 rounded-full bg-black/60 border border-[#a6e22e]/40 text-[#a6e22e] inline-flex items-center gap-1">
        <Flame size={12}/> {product.thc}
      </span>

      <Link to={`/produkt/${product.id}`} className="block relative aspect-square bg-gradient-to-b from-white/5 to-transparent overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className={`h-full w-full object-contain p-5 transition-transform duration-500 group-hover:scale-110 ${!product.inStock ? 'opacity-40 grayscale' : ''}`}
        />
        {!product.inStock && (
          <span className="absolute inset-0 flex items-center justify-center font-bangers text-2xl text-white/80 text-outline">WKRÓTCE DOSTĘPNE</span>
        )}
      </Link>

      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-center gap-1 text-[#ffb000] mb-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={13} className={i < Math.round(product.rating) ? 'fill-[#ffb000]' : 'opacity-30'} />
          ))}
          <span className="text-white/50 text-xs ml-1">({product.reviews})</span>
        </div>
        <Link to={`/produkt/${product.id}`} className="font-anton text-2xl leading-tight uppercase hover:text-[#a6e22e] transition-colors">
          <CaliLetters text={product.name.toUpperCase()} />
        </Link>
        <p className="text-white/50 text-xs mb-3">{product.subtitle}</p>

        <div className="mt-auto flex items-end justify-between gap-2">
          <div>
            {product.oldPrice && (
              <span className="text-white/40 line-through text-xs mr-1">{product.oldPrice.toFixed(2)} zł</span>
            )}
            <span className="text-[#a6e22e] font-bold text-lg">od {product.price.toFixed(2)} zł</span>
          </div>
          <button
            disabled={!product.inStock}
            onClick={() => addItem(product)}
            className={`text-sm px-4 py-2 rounded-full font-bold transition ${product.inStock ? 'btn-green' : 'bg-white/10 text-white/40 cursor-not-allowed'}`}
          >
            {product.inStock ? 'Do koszyka' : 'Wkrótce'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
